import {Injectable} from "@angular/core";
import {AbstractResourceService} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {TerritoryDTO} from "@well/domain";

@Injectable({
  providedIn: 'root'
})
export class CompanyTerritoryResourceService extends AbstractResourceService<undefined, TerritoryDTO, undefined, undefined> {

  constructor(protected httpClient: HttpClient, private environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('companyTerritoryUrl'),
      undefined,
      TerritoryDTO
    );
  }
}
